<template>
  <div class="about">
    <div class="quit">
      <img src="../assets/images/quit.png" alt="" @click="goAbout" />
    </div>
    <div
      id="container"
      ref="container"
      v-on="{ click: videoMenuShow, touchstart: videoMenuShow }"
    ></div>

    <template>
      <div class="test" v-if="testFlag">
        <div class="text" @click="testClick"></div>
      </div>
    </template>

    <video
      id="video"
      loop
      crossorigin="anonymous"
      style="display: none"
      ref="video"
      @timeupdate="videoEvent"
      :volume="volume"
      webkit-playsinline="true"
      playsinline="true"
    ></video>

    <div class="video-menu" :style="{ bottom: videoMenuTop }">
      <div class="ifPlay" @click="playEvent">
        <img
          src="../assets/images/suspend.png"
          alt=""
          :style="{ display: `${img1flag ? 'block' : 'none'}` }"
          class="img1"
        />
        <img
          src="../assets/images/play.png"
          alt=""
          :style="{ display: `${img1flag ? 'none' : 'block'}` }"
          class="img2"
        />
      </div>
      <div class="progress-bar" @click="progressEvent" ref="progressBar">
        <div class="progress" :style="{ width: progressWidth }"></div>
      </div>
      <div class="time-box">
        <span class="time1">{{ time1 }}</span
        >/<span class="time2">{{ time2 }}</span>
      </div>

      <div class="volume-box">
        <div class="img-box" @click="shutVolume">
          <img
            src="../assets/images/volumeOff.png"
            alt=""
            :style="{ display: `${volume == 0 ? 'block' : 'none'}` }"
            class="img1"
          />
          <img
            src="../assets/images/volumeOn.png"
            alt=""
            :style="{ display: `${volume == 0 ? 'none' : 'block'}` }"
            class="img2"
          />
        </div>

        <!-- <div class="volume-progress-box" @click="volumeChange" ref="volumeProgress">
          <div class="volume-progress" :style="{ width: volume*100+'%' }"></div>
        </div> -->
      </div>

      <div :class="['AR', { active: ARFlag }]" @click="ARChange">AR</div>
    </div>
  </div>
</template>

<script>
import * as THREE from "../assets/js/three/build/three.module";
import { OrbitControls } from "../assets/js/three/examples/jsm/controls/OrbitControls";
import { DeviceOrientationControls } from "../assets/js/three/examples/jsm/controls/DeviceOrientationControls.js";

import RZvideo from "../assets/videos/rzfy4k-new.mp4";

let scene, camera, renderer;

let controls;
let device;
let ar_mode = false;

// 销毁的东西
let geometry;
let texture;
let material;
let mesh;

function isIos() {
  var u = navigator.userAgent;
  if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
    return true;
  }
  return false;
}

export default {
  data() {
    return {
      videoName: "",
      testFlag: true,
      videoMenuTop: "-60px",
      // videoMenuTop: "0px",
      img1flag: true,
      progressWidth: "0%",
      time1: null,
      time2: null,
      timer: null,
      ARFlag: false,
      volume: 1,
    };
  },
  components: {},
  methods: {
    init() {
      scene = new THREE.Scene();

      // 视野角度，长宽比，近截面，远截面
      camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        1,
        1100
      );
      camera.position.set(1, 0, 0);

      renderer = new THREE.WebGLRenderer();
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(window.innerWidth, window.innerHeight);
      this.$refs.container.appendChild(renderer.domElement);

      controls = new OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.rotateSpeed = -0.5;
      controls.enableZoom = false;
      controls.enablePan = false;

      device = new DeviceOrientationControls(camera);
      device.enabled = false;
    },
    addMesh() {
      geometry = new THREE.SphereGeometry(500, 60, 40);
      // invert the geometry on the x-axis so that all of the faces point inward
      geometry.scale(-1, 1, 1);

      // video.play();

      // console.log(video);

      texture = new THREE.VideoTexture(video);
      material = new THREE.MeshBasicMaterial({ map: texture });

      mesh = new THREE.Mesh(geometry, material);
      scene.add(mesh);
    },
    render() {
      // console.log(this);
      // return
      requestAnimationFrame(this.render);
      renderer.render(scene, camera);
      if (ar_mode) {
        device.update();
      } else {
        controls.update();
      }
    },
    eventSet() {
      window.addEventListener("resize", this.onWindowResize);
      window.addEventListener("orientationchange", function () {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
      });
    },
    onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();

      renderer.setSize(window.innerWidth, window.innerHeight);
    },
    testClick() {
      this.testFlag = false;

      this.playEvent();
    },
    playEvent() {
      if (video.paused) {
        // 开始播放
        video.play();
      } else {
        // 暂停
        video.pause();
      }
      this.img1flag = !this.img1flag;
    },
    videoEvent() {
      let video = video || this.$refs.video;
      if (!video) return;
      let startTime = video.currentTime;
      let startTimeMin =
        Math.floor(startTime / 60) >= 10
          ? Math.floor(startTime / 60)
          : "0" + Math.floor(startTime / 60);
      let startTimeS =
        Math.floor(startTime % 60) >= 10
          ? Math.floor(startTime % 60)
          : "0" + Math.floor(startTime % 60);
      let resStartTime = startTimeMin + ":" + startTimeS;

      let endTime = video.duration;

      this.time1 = resStartTime;
      if (!this.time2) {
        if (isNaN(endTime)) {
          this.time2 = null;
        } else {
          let endTimeMin =
            Math.floor(endTime / 60) >= 10
              ? Math.floor(endTime / 60)
              : "0" + Math.floor(endTime / 60);
          let endTimeS =
            Math.floor(endTime % 60) >= 10
              ? Math.floor(endTime % 60)
              : "0" + Math.floor(endTime % 60);
          let resEndTime = endTimeMin + ":" + endTimeS;
          this.time2 = resEndTime;
        }
      }
      this.progressWidth = (startTime / endTime) * 100 + "%";
    },
    progressEvent(e) {
      e = e || event;
      let endTime = video.duration;
      let currentTime =
        ((e.clientX - this.$refs.progressBar.offsetLeft) /
          this.$refs.progressBar.clientWidth) *
        endTime;
      currentTime = currentTime.toFixed(2);
      let currentTimeMin =
        Math.floor(currentTime / 60) >= 10
          ? Math.floor(currentTime / 60)
          : "0" + Math.floor(currentTime / 60);
      let currentTimeS =
        Math.floor(currentTime % 60) >= 10
          ? Math.floor(currentTime % 60)
          : "0" + Math.floor(currentTime % 60);
      let resStartTime = currentTimeMin + ":" + currentTimeS;

      video.currentTime = currentTime;

      this.time1 = resStartTime;

      this.progressWidth = (currentTime / endTime) * 100 + "%";
    },
    videoMenuShow() {
      this.videoMenuTop = "0px";
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.videoMenuTop = "-60px";
      }, 3000);
    },
    ARChange() {
      if (isIos()) {
        // 苹果手机

        //IOS13+ 授权流程
        window.DeviceOrientationEvent.requestPermission().then((state) => {
          switch (state) {
            case "granted":
              // you can do something
              break;
            case "denied":
              alert("你拒绝了使用陀螺仪");
              break;
            case "prompt":
              alert("其他行为");
              break;
          }
        });
      }
      if (ar_mode) {
        this.ARFlag = !this.ARFlag;
        ar_mode = false;
        controls.enabled = true;
        device.enabled = false;
        controls.update();
        device.update();
      } else {
        this.ARFlag = !this.ARFlag;
        ar_mode = true;
        controls.enabled = false;
        device.enabled = true;
        controls.update();
        device.update();
      }
    },
    shutVolume() {
      this.volume = this.volume == 0 ? 1 : 0;
      this.$refs.video.volume = this.volume;
    },
    volumeChange(e) {
      e = e || event;
      let currentVolume =
        (e.clientX - this.$refs.volumeProgress.offsetLeft) /
        this.$refs.volumeProgress.clientWidth;
      currentVolume = Number(currentVolume.toFixed(2));
      this.volume = currentVolume;
      this.$refs.video.volume = this.volume;
    },
    goAbout() {
      if (this.$route.params.video == "RZvideo") {
        this.$router.replace("/about/" + this.$route.params.about);
      }
    },
  },

  mounted() {
    this.init();
    this.addMesh();
    this.render();
    this.eventSet();

    if (this.$route.params.video == "RZvideo") {
      this.$refs.video.src = RZvideo;
    }

    // alert(window.DeviceMotionEvent)
  },
  beforeDestroy() {
    // console.log(scene);
    scene.remove(mesh);

    // clean up

    geometry.dispose();
    material.dispose();
    texture.dispose();
  },
};
</script>

<style scoped>
#container {
  width: 100vw;
  height: 100vh;
}
#container canvas {
  width: 100vw;
  height: 100vh;
}

canvas {
  overflow: scroll;
}

.video-menu {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  bottom: 0px;
  transition: all 0.1s;
  z-index: 100;
  padding-top: 8px;
  box-sizing: border-box;
}

.video-menu .ifPlay {
  width: 45px;
  height: 45px;
  margin-top: 3.5px;
  margin-left: 20px;
  float: left;
  font-size: 0;
  cursor: pointer;
}
.video-menu .ifPlay img {
  width: 100%;
  height: 100%;
}

.video-menu .progress-bar {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background-color: white;
  position: absolute;
  top: 0px;
  cursor: pointer;
}

.video-menu .progress {
  background-color: violet;
  border-radius: 4px;
  height: 100%;
}

.video-menu .time-box {
  float: left;
  height: 40px;
  line-height: 40px;
  margin-top: 6px;
  margin-left: 10px;
  color: #fff;
  font-size: 18px;
}

.video-menu .AR {
  width: 60px;
  height: 40px;
  line-height: 40px;
  float: right;
  font-size: 18px;
  color: #afafaf;
  border: 1px solid #afafaf;
  border-radius: 20px;
  margin-top: 6px;
  margin-right: 20px;
  cursor: pointer;
  display: none;
}

.video-menu .active {
  color: aqua;
  border-color: aqua;
}

.video-menu .volume-box {
  /* width: 100px; */
  height: 30px;
  /* background-color: yellow; */
  float: left;
  margin-top: 11px;
  margin-left: 20px;
}

.video-menu .volume-box .img-box {
  width: 30px;
  height: 30px;
  float: left;
  font-size: 0;
  cursor: pointer;
}

.video-menu .volume-box .img-box img {
  width: 100%;
  height: 100%;
}

.video-menu .volume-box .volume-progress-box {
  width: 60px;
  height: 8px;
  background-color: #afafaf;
  float: left;
  margin-left: 5px;
  margin-top: 11px;
  border-radius: 4px;
}

.video-menu .volume-box .volume-progress-box .volume-progress {
  height: 8px;
  background-color: aqua;
  border-radius: 4px;
}

.test {
  width: 100%;
  height: 100%;
  position: fixed;
  background-image: url("../assets/images/video1.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  top: 0;
  left: 0;
}
.test .text {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  /* background-color: blueviolet; */
  background-image: url("../assets/images/suspend.png");
  background-size: cover;
  color: red;
  transform: translate(-50%, -50%);
  text-align: center;
  line-height: 100px;
  cursor: pointer;
  font-size: 18px;
}

.quit {
  position: fixed;
  width: 1.18rem;
  height: 0.48rem;
  top: 10px;
  left: 10px;
  z-index: 999;
}
.quit img {
  width: 100%;
  height: 100%;
}
</style>
